"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tableau_expression_parser_js_1 = require("@tableau/tableau-expression-parser-js");
var antlr4_1 = require("antlr4");
function tokensFromTableauExpression(expression) {
    var inputStream = new antlr4_1.InputStream(expression);
    var lexer = new tableau_expression_parser_js_1.TableauExpressionLexer(inputStream);
    lexer.removeErrorListeners();
    var tokens = lexer.getAllTokens();
    return tokens;
}
exports.tokensFromTableauExpression = tokensFromTableauExpression;
function trimBrackets(expression) {
    var firstBracket = expression.indexOf('[');
    if (firstBracket !== -1) {
        var lastBracket = expression.lastIndexOf(']');
        if (lastBracket !== -1) {
            return unescapeBrackets(expression.substr(firstBracket + 1, lastBracket - firstBracket - 1));
        }
        else {
            return unescapeBrackets(expression.substr(firstBracket + 1));
        }
    }
    return expression;
}
exports.trimBrackets = trimBrackets;
function unescapeBrackets(expression) {
    return expression.replace(/]]/g, ']');
}
exports.unescapeBrackets = unescapeBrackets;
//# sourceMappingURL=TableauExpressionFunctions.js.map